import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { ExecutingUnit } from '../entities/executingUnit';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum'; 
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { User } from '../model/user';
import { Observable } from 'rxjs/Observable';
import { tap, catchError, switchAll } from 'rxjs/operators';


interface ExtraSearchFields {
  //user? :User;
}

@Injectable()
export class UserMassiveLoadService extends BaseCrudService<User> {

  public uri = '/api/userMassiveLoad/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance UserMassiveLoadService');
  }

  buildSentence(entity?: User, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields ): HttpParams { 
    /*if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        entity && entity.userName ?
          `userName${QueryOperator.Equal}${entity.userName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      
    //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }  
    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;*/
    return null
  }
   
 
    getUserMassiveLoad(eu :ExecutingUnit) : Observable<any> {
      //console.log(eu);
      const url = `${this.rutaServidor}${this.uri}executeMassive`  ;  
      return this.httpClient.post(url,eu); 
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/user-massive-load.service.ts